// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox {
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  -webkit-user-select: none;
  user-select: none;
  cursor: pointer;
}

.checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: relative;
  display: block;
  height: 20px;
  width: 20px;
  background-color: white;
  border: 1.5px solid #e1e1e1;
  border-radius: 2px;
}

.checkmark-red {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: white;
  border: 1.5px solid #e1e1e1;
  border-radius: 2px;
}

.checkbox:hover input ~ .checkmark {
  background-color: white;
}

.checkbox input:checked ~ .checkmark {
  background: #00b09e;
  border: 1.5px solid #00b09e;
}

.checkbox input:checked ~ .checkmark-red {
  background: #ce1514;
  border: 1.5px solid #ce1514;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox input:checked ~ .checkmark:after {
  display: block;
}

.checkbox .checkmark:after {
  top: -1px;
  left: 0px;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.checkmark-red:after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox input:checked ~ .checkmark-red:after {
  display: block;
}

.checkbox .checkmark-red:after {
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.checkbox-text {
  margin-left: 5px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
}`, "",{"version":3,"sources":["webpack://./src/common/checkbox/checkbox.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;EACA,eAAA;AACJ;;AAEA;EACI,kBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;AACJ;;AAEA;EACI,kBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;EACA,2BAAA;EACA,kBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;EACA,2BAAA;EACA,kBAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,mBAAA;EACA,2BAAA;AACJ;;AAEA;EACI,mBAAA;EACA,2BAAA;AACJ;;AAEA;EACI,WAAA;EACA,kBAAA;EACA,aAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,SAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EAGA,wBAAA;AACJ;;AAEA;EACI,WAAA;EACA,kBAAA;EACA,aAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EAGA,wBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACJ","sourcesContent":[".checkbox {\n    display: flex;\n    position: relative;\n    width: 100%;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n    font-size: 22px;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    cursor: pointer;\n}\n\n.checkbox input {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n}\n\n.checkmark {\n    position: relative;\n    display: block;\n    height: 20px;\n    width: 20px;\n    background-color: white;\n    border: 1.5px solid #e1e1e1;\n    border-radius: 2px;\n}\n\n.checkmark-red {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 20px;\n    width: 20px;\n    background-color: white;\n    border: 1.5px solid #e1e1e1;\n    border-radius: 2px;\n}\n\n.checkbox:hover input ~ .checkmark {\n    background-color: white;\n}\n\n.checkbox input:checked ~ .checkmark {\n    background: #00b09e;\n    border: 1.5px solid #00b09e;\n}\n\n.checkbox input:checked ~ .checkmark-red {\n    background: #ce1514;\n    border: 1.5px solid #ce1514;\n}\n\n.checkmark:after {\n    content: '';\n    position: absolute;\n    display: none;\n}\n\n.checkbox input:checked ~ .checkmark:after {\n    display: block;\n}\n\n.checkbox .checkmark:after {\n    top: -1px;\n    left: 0px;\n    right: 0;\n    bottom: 0;\n    margin: auto;\n    width: 5px;\n    height: 10px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    -webkit-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    transform: rotate(45deg);\n}\n\n.checkmark-red:after {\n    content: '';\n    position: absolute;\n    display: none;\n}\n\n.checkbox input:checked ~ .checkmark-red:after {\n    display: block;\n}\n\n.checkbox .checkmark-red:after {\n    left: 6px;\n    top: 2px;\n    width: 5px;\n    height: 10px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    -webkit-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    transform: rotate(45deg);\n}\n\n.checkbox-text {\n    margin-left: 5px;\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #333333;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
